function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 5h21v50H18zM3 25.848h15V55H3zM39 25.848h15V55H39z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 21h3v3h-3zM27 21h3v3h-3zM33 21h3v3h-3zM27 29h3v3h-3zM21 29h3v3h-3zM33 29h3v3h-3zM21 37h3v3h-3zM27 37h3v3h-3zM33 37h3v3h-3zM21 43h15v12H21zM27 8.5V11h-2.5v3H27v2.5h3V14h2.5v-3H30V8.5zM16 2h25v3H16z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M28.5 43v12"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 29h11v3H5zM5 37h11v3H5zM5 45h11v3H5zM41 29h11v3H41zM41 37h11v3H41zM41 45h11v3H41z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M27 48v2M30 48v2"
}));

var SvgHospital = function SvgHospital(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHospital, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Hospital.7b6b0b44.svg";
export { ForwardRef as ReactComponent };